import React, { Component } from "react";
import { UploadOutlined } from "@ant-design/icons";
import { Button, Col, Form, message, Collapse, Modal, Row, Spin, Typography, Space, Image, InputNumber, Divider } from 'antd';
import { EditableProTable } from '@ant-design/pro-table';

import moment from "moment";
import { renderEstatusOrdenCompra } from "../../../Utils";

const axios = require('axios').default;
const { Title, Text } = Typography;
const { Panel } = Collapse;

/**
 *
 *
 * @export
 * @class ModalOrdenCompraDetalles
 * @extends {Component}
 */
class ModalOrdenCompraDetalles extends Component {


    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            orden_compra: {},
            orden_detalles: [],

            
        }
    }

    componentDidMount() {
        axios.defaults.headers.common['Authorization'] = sessionStorage.getItem('token');
        if(this.props.orden_compra_id) {
            this.getOrdenCompra()
        }
    }

    /**
     *
     *
     * @memberof ModalOrdenCompraDetalles
     * @method getOrdenCompra
     * @description Obtiene la orden de compra y los detalles de esta
     */
    getOrdenCompra = () => {
        this.setState({loading: true})
        axios.get('/ordenesCompra/get', {
            params: {
                id: this.props.orden_compra_id
            }
        })
            .then(({data}) => {
                console.clear()
                console.log(data)
                this.setState({
                    orden_compra: data.data,
                    orden_detalles: data.orden_detalles,
                })
            })
            .catch(error => {
                console.log(error)
            })
            .finally(() => {
                this.setState({loading: false})
            })

    }



    render() {
        const { loading, orden_compra, orden_detalles } = this.state;

        return (
            <Spin spinning={loading} size="large" tip="Cargando...">
               <Row gutter={[16, 16]} className="mb-2">
                    <Col span={24} className="center">
                        <Title level={3}>Detalles de la orden de compra</Title>
                    </Col>
                    <Col span={8} className="flex-column">
                        <Text strong>Folio: </Text>
                        <Text>{orden_compra?.folio}</Text>
                    </Col>
                    <Col span={8} className="flex-column">
                        <Text strong>Fecha: </Text>
                        <Text>{moment(orden_compra?.createdAt).format("DD/MM/YYYY HH:mm")}</Text>
                    </Col>
                    <Col span={8} className="flex-column">
                        <Text strong>Estatus: </Text>
                        <Text>{renderEstatusOrdenCompra(orden_compra?.estatus)}</Text>
                    </Col>
                    <Col span={8} className="flex-column">
                        <Text strong>Cliente: </Text>
                        <Text>{orden_compra?.cliente_id?.nombre_completo}</Text>
                    </Col>
                    <Col span={8} className="flex-column">
                        <Text strong>Proveedor: </Text>
                        <Text>{orden_compra?.proveedor_id?.nombre_comercial}</Text>
                    </Col>
                    <Col span={8} className="flex-column">
                        <Text strong>Monto Total: </Text>
                        <Text>$ {orden_compra?.monto_total?.toMoney(true)} MXN</Text>
                    </Col>
                    <Col span={8} className="flex-column">
                        <Text strong>Fecha de Entrega: </Text>
                        <Text>{orden_compra?.fecha_entrega ? moment(orden_compra?.fecha_entrega).format("DD/MM/YYYY") : "Sin Fecha"}</Text>
                    </Col>
                    <Col span={8} className="flex-column">
                        <Text strong>Almacén: </Text>
                        <Text>{orden_compra?.almacen_id?.direccion}</Text>
                    </Col>
                    <Col span={24} className="center">
                        <Title level={4}>Productos y Recepciones</Title>
                    </Col>
                    <Col span={24}>
                        <Row gutter={[16, 16]} className="mb-1">
                            <Col span={4} className="center">
                                <Text strong>Producto <br/><small>NP Fabricante</small></Text>
                            </Col>
                            <Col span={5} className="center">
                                <Text strong>Costo</Text>
                            </Col>
                            <Col span={5} className="center">
                                <Text strong>Costo Total</Text>
                            </Col>
                            <Col span={5} className="center">
                                <Text strong>Cantidad</Text>    
                            </Col>
                            <Col span={5} className="center">
                                <Text strong>Cantidad Recibida</Text>
                            </Col>
                        </Row>
                        <Collapse>
                            {orden_detalles.map(od => <Panel style={{backgroundColor: "#2d348c"}}
                                header={
                                    <Row gutter={[16, 16]}>
                                        <Col span={4} className="center text-white">
                                            {od?.producto_id?.np_fabricante}
                                        </Col>
                                        <Col span={5} className="center text-white">
                                            $ {od?.info_matriz?.costo?.toMoney(true)} MXN
                                        </Col>
                                        <Col span={5} className="center text-white">
                                            $ {od?.info_matriz?.costo_total?.toMoney(true)} MXN
                                        </Col>
                                        <Col span={5} className="center text-white">
                                            {od?.cantidad}
                                        </Col>
                                        <Col span={5} className="center text-white">
                                            {od?.cantidad_recibida}
                                        </Col>
                                    </Row>
                                } 
                                key={od._id}
                            >
                                <Row gutter={[16, 16]} className="mb-1">
                                    <Col span={4} className="center">
                                        <Text strong>Fecha</Text>
                                    </Col>
                                    <Col span={5} className="center">
                                        <Text strong>Folio</Text>
                                    </Col>
                                    <Col span={5} className="center">
                                        <Text strong>Nombre</Text>
                                    </Col>
                                    <Col span={5} className="center">
                                        <Text strong>Cantidad Recibida</Text>    
                                    </Col>
                                    <Col span={5} className="center">
                                        <Text strong>Archivos</Text>
                                    </Col>
                                </Row>
                                {od?.recepciones?.map(({entrega_recepcion_id, cantidad, firma,_id}, index) =><><Row key={_id} gutter={[16, 16]}>
                                        <Col span={4} className="center">
                                            {moment(entrega_recepcion_id?.fecha).format("DD/MM/YYYY")}
                                        </Col>
                                        <Col span={5} className="center">
                                            {entrega_recepcion_id?.folio}
                                        </Col>
                                        <Col span={5} className="center">
                                            <Text strong>{entrega_recepcion_id.nombre}</Text>
                                        </Col>
                                        <Col span={5} className="center">
                                            {cantidad}
                                        </Col>
                                        <Col span={5} className="flex-column">
                                            <ul style={{ padding: 0}}>
                                                {entrega_recepcion_id.firma ? <li><a 
                                                    href={axios.defaults.baseURL + "/upload/" + entrega_recepcion_id.firma} 
                                                    target="_blank" 
                                                    rel="noopener noreferrer"
                                                >{entrega_recepcion_id.firma}</a> </li>: null}
                                                {entrega_recepcion_id.archivos?.map((archivo, index) => <li><a
                                                    key={index}
                                                    href={axios.defaults.baseURL + "/voucher/" + archivo}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >{archivo}</a></li>)}
                                            </ul>
                                        </Col>
                                    </Row>
                                    <Divider style={{margin: "8px"}}/>             
                                </>)}
                            </Panel>)}
                            
                        </Collapse>
                    </Col>
               </Row>
                
            </Spin>
        )
    }
}

/**
 * @description Según el modal
 */
export default function (props) {

    const { visible, onClose } = props

    return (
        <Modal
            visible={visible}
            onCancel={onClose}
            title={null}
            footer={null}
            closable={false}
            maskClosable={true}
            destroyOnClose={true}
            zIndex={1000}
            width={1000}
        >
            <ModalOrdenCompraDetalles {...props} />
        </Modal>
    )
}
